import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("KeyboardShortcutController connected");
    document.addEventListener("keydown", this.handleKeydown.bind(this))
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown.bind(this))
  }

  handleKeydown(event) {
    if (event.key === "/") {
      console.log("Slash key pressed");
      event.preventDefault()
      const searchInput = document.getElementById("search-input")
      if (searchInput) {
        searchInput.focus()
      }
    }
  }
}
